<template>
  <v-card min-width="21vw" align="center" justify="center" light outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>Delete Trade</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="pt-3 pb-5">
      <v-container fluid>
        <v-row align="center" justify="center">
          <p>Are you sure you want to delete the <b>{{ trade.asset.ticker }}</b> trade?</p>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-btn @click="deleteTrade" class="mr-5">Delete</v-btn>
          <v-btn @click="closeWindow">Close</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/trades';
export default {
name: "DeleteTrade",
  props: {
  trade: Object,
  },
  methods: {
    deleteTrade() {
      Repository.deleteTrade(this.trade.id).then((response) => {
        if(response.status < 400) {
          alert('Trade was successfully deleted');
          this.$emit('alreadyDeleted');
        }
      });
    },
    closeWindow() {
      this.$emit('closeWindow');
    }
  }
}
</script>

<style scoped>

</style>
